import styled from 'styled-components'

export const SwitchesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  margin: 1.5rem 0;
  padding: 1rem;
  background-color: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
`

export const SwitchRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const SwitchLabelText = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
  font-weight: 500;
  color: #374151;
`

export const SwitchBox = styled.label`
  display: inline-block;
  position: relative;
  width: 50px;
  height: 28px;
`

export const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  :checked + .slider {
    background-color: #2196F3;
    border: 0;
  }

  :focus + .slider {
    box-shadow: 0 0 1px #2196F3;
  }

  :checked + .slider:before {
    -webkit-transform: translateX(22px);
    -ms-transform: translateX(22px);
    transform: translateX(22px);
  }

  :disabled + .slider {
    background-color: #9ca3af;
    cursor: not-allowed;
  }
`

export const SwitchSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 34px;

  :before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 50%;
  }
`
